import React, { useEffect, useState } from 'react';
import { Button, CircularProgress, Fab, Zoom } from '@mui/material';
import { useGameContext } from '../../contexts/GameContext';
import { useSessionContext } from '../../contexts/SessionContext';
import { useFinishGame } from '../../hooks/Game/useFinishGame';
import { useNavigate } from 'react-router-dom';
import { PATHS } from '../../routes';
import ModalCard from '../ui/ModalCard';
import Icon from '../ui/Icon';

const FinishGame: React.FC = () => {
  const { user_id } = useSessionContext();
  const { code, finished, adminId, gameStarted } = useGameContext();

  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const { finishGame } = useFinishGame(code);

  useEffect(() => {
    if (finished) {
      setOpen(false);
      setLoading(false);
    }
  }, [finished]);

  const isAdmin = user_id === adminId;

  const handleSubmit = async () => {
    if (!isAdmin) {
      navigate(PATHS.GAME.HOME());
    } else {
      setLoading(true);
      await finishGame();
    }
  }

  if (!code) {
    return null;
  }

  return (
    <>
      <Zoom
        in={!open && gameStarted && !finished}
        timeout={100}
        unmountOnExit
        style={{
          transitionDelay: "100ms",
          position: 'fixed',
          top: 76,
          right: 12,
          zIndex: 10,
        }}
      >
        <Fab
          color="error"
          aria-label={isAdmin ? "Terminar partida" : "Sair da partida"}
          onClick={() => setOpen(true)}
          size="medium"
        >
          <Icon name={isAdmin ? "end" : "leave"} size={20} />
        </Fab>
      </Zoom>

      <ModalCard
        open={open}
        onClose={() => setOpen(false)}
        title={isAdmin ? "Terminar a partida?" : "Sair da partida?"}
        icon={isAdmin ? "heavy" : "leave"}
        tone="cherry"
        width={400}
        actions={
          <>
            <Button
              variant="contained"
              color="success"
              startIcon={<Icon name="play" />}
              onClick={() => setOpen(false)}
              disabled={loading}
            >
              Continuar jogando
            </Button>
            <Button
              variant="contained"
              color="error"
              startIcon={
                loading ? (
                  <CircularProgress size={18} color="inherit" />
                ) : (
                  <Icon name={isAdmin ? "end" : "leave"} />
                )
              }
              onClick={handleSubmit}
              disabled={loading}
            >
              {isAdmin ? "Terminar" : "Sair"}
            </Button>
          </>
        }
      >
        <p style={{ margin: 0, fontWeight: 600, color: "var(--ink-soft)" }}>
          {isAdmin
            ? "A partida acaba pra todo mundo e o ranking final aparece."
            : "Você pode voltar depois com o código da sala."}
        </p>
      </ModalCard>
    </>
  );
}

export default FinishGame;
